import { Avatar } from "antd";
import vivoLogoUrl from "@/assets/icons/vivo_logo_white.svg";
import { getAvatarColor, getInitials } from "@/utils/avatarUtils";
import { InsightProps } from "./insights";

interface InsightAvatarProps {
  insight: InsightProps;
  userName?: string;
}

export default function InsightAvatar({
  insight,
  userName,
}: InsightAvatarProps) {
  if (insight.is_shared) {
    return (
      <div className="flex items-center justify-center w-6 h-6 rounded-full bg-[#394C54]">
        <img src={vivoLogoUrl} width={12} height={8} alt="Vivo" />
      </div>
    );
  }

  const initials = getInitials(userName || "U");
  const bgColor = getAvatarColor(userName || "User");

  return (
    <Avatar
      style={{
        backgroundColor: bgColor,
      }}
      size="small"
    >
      {initials}
    </Avatar>
  );
}
